import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {
    GetMcfxAudiencesFromApi_mcfxAudiencesViaApi as McfxAudienceFromApi,
    GetMcfxAudiencesFromApi as GetMcfxAudiencesFromApiQuery,
} from 'nutshell-graphql-types';

import GET_MCFX_AUDIENCES_FROM_API from '../queries/get-mcfx-audiences-from-api.graphql';

export const useGetMcfxAudiencesFromApi = (
    shouldSkip: boolean
): {
    isLoading: boolean;
    errorMessage: string | null | undefined;
    mcfxAudiencesViaApi: McfxAudienceFromApi[];
    refetch: () => Promise<any>;
} => {
    const {loading, refetch, data, error} = useQuery<
        GetMcfxAudiencesFromApiQuery,
        Record<any, any>
    >(GET_MCFX_AUDIENCES_FROM_API, {
        notifyOnNetworkStatusChange: true,
        skip: shouldSkip,
    });

    return {
        isLoading: loading,
        refetch,
        // @ts-expect-error
        errorMessage: safelyGetGraphQLErrorMessage(error),
        mcfxAudiencesViaApi: data ? data.mcfxAudiencesViaApi : [],
    };
};
